module.exports = __webpack_public_path__ + "static/media/volunteer-min.20109342.png";